import React, { Component } from "react";
import CloseSqaure from "../../../assets/images/auth/close-square.png";
import PlusIcon from "../../../assets/images/auth-home/plus-icon.png";
import Media from "../../../assets/images/auth-home/media-icon.png";
import Video from "../../../assets/images/auth-home/video-icon.png";
import Search from "../../../assets/images/auth-home/search-icon.png";
import Attachment from "../../../assets/images/auth-home/attachment-icon.png";
import Brackets from "../../../assets/images/auth-home/brackets.png";
import Collapse from "react-bootstrap/Collapse";
import Arrowback from "../../../assets/images/auth/arrow-back.png";

class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      content: "",
      isCollapseOpen: false,
      showBeforeCollapse: true,
      showAfterCollapse: false,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.vale });
  };

  handlePublish = () => {
    alert("Blog Published");
    this.props.closeModal();
  };

  render() {
    return (
      <React.Fragment>
        {this.props.width > 768 ? (
          <div className="d-flex justify-content-end">
            <img
              src={CloseSqaure}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={this.props.closeModal}
            />
          </div>
        ) : (
          <div className="row align-items-center">
            <div className="col-5">
              <img src={Arrowback} alt="" onClick={this.props.closeModal} />
            </div>
            <div
              className="col-7 px-0"
              style={{ color: "#181818", fontSize: 18, fontFamily: "Poppins" }}
            >
              Blog
            </div>
          </div>
        )}
        <div
          className="row px-md-4"
          style={{ marginTop: this.props.width > 992 ? 90 : 48 }}
        >
          <div className="col-12">
            <input
              type="text"
              className="form-control th-auth-home-form-control w-100 mb-2"
              placeholder="Title"
              name="title"
              value={this.state.title}
              onChange={this.handleChange}
            />
          </div>
          <div className="col-12 mt-3 mb-2">
            <textarea
              rows="5"
              className="form-control th-auth-home-form-control w-100"
              placeholder="Type your content here"
              name="content"
              value={this.state.content}
              onChange={this.handleChange}
            />
          </div>
          <div className="col-12 mb-4 mt-md-2 mt-1 d-flex">
            {/* collapsing icon */}
            {this.state.showAfterCollapse || this.state.showBeforeCollapse ? (
              <div
                className="th-auth-home-blog-popup-icons-box"
                onClick={() =>
                  this.setState({
                    isCollapseOpen: true,
                  })
                }
              >
                <img
                  src={PlusIcon}
                  alt=""
                  style={{ cursor: "pointer" }}
                  width={8.5}
                  className="th-auth-home-blog-popup-plus"
                />
              </div>
            ) : null}
            {/* collapsed horizontal menu */}
            <Collapse
              in={this.state.isCollapseOpen}
              onExited={() => {
                this.setState({
                  showAfterCollapse: true,
                  showBeforeCollapse: false,
                });
              }}
              onEntering={() => {
                this.setState({
                  showAfterCollapse: false,
                  showBeforeCollapse: false,
                });
              }}
              dimension="width"
              style={{
                border: "1px solid #707070",
                padding: "6px 0",
                borderRadius: 13,
              }}
            >
              <div>
                <div className="d-flex align-items-center">
                  <img
                    src={PlusIcon}
                    alt=""
                    style={{ cursor: "pointer" }}
                    width={8}
                    className="th-auth-home-blog-popup-cross mx-2"
                    onClick={() =>
                      this.setState({
                        isCollapseOpen: false,
                      })
                    }
                  />
                  <img
                    src={Media}
                    alt=""
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    src={Video}
                    alt=""
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    src={Attachment}
                    alt=""
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    src={Search}
                    alt=""
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                  />
                  <img
                    src={Brackets}
                    alt=""
                    className="mx-2"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
            </Collapse>
            {/*  */}
          </div>
        </div>
        <div className="d-flex justify-content-md-end justify-content-center th-auth-popup-btn-wraper">
          {this.props.width > 780 && (
            <div
              className="btn th-auth-popup-btn1 mx-2"
              onClick={this.props.closeModal}
            >
              Close
            </div>
          )}
          <div className="btn th-auth-popup-btn2" onClick={this.handlePublish}>
            Publish
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Blog;
